<template>
<ul class="related-many related-many-tags">
  <li v-for="(item, ii) in value">
    {{ item?.property?.title }}
    {{ item?.brand?.title }}
    <a class="remove" href="" v-on:click.prevent="removeItem(ii)">&times;</a>
  </li>
  <li class="new">
    <FormSelect :options="targetItems" v-model="newItemId" @update:modelValue="addNew" />
<!--     <button class="btn btn-primary" @click.prevent="addNew">Add</button> -->
  </li>
</ul>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    value: [],
    targetItems: [],
    targetSearch: "",
    newItemId: null,
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      }, deep: true,
    },
    modelValue: {
      handler() {
        this.value=this.modelValue || [];
      }, immediate: true, deep: true,
    },
    targetSearch() {
      clearTimeout(this.loadTargetTimeout);
      this.loadTargetTimeout=setTimeout(()=>this.loadTargetItems(), 1000);
    },
  },
  computed: {
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew() {
      this.$nextTick(()=>{
        var newItem={};
        for(var field in this.fieldDesc) {
          if (field!=this.dbfield.name)
            newItem[field]=null;
        }
        var targetItem=this.targetItems.find(item=>item.value==this.newItemId);
        if (targetItem?.property)
          newItem.property=targetItem.property;
        if (targetItem?.brand)
          newItem.brand=targetItem.brand;
        this.newItemId=null;
        this.targetSearch="";
        this.value.push(newItem);
      });
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
    async loadTargetItems() {
//       this.targetItems=[];
      var where=[];
      if (this.targetSearch)
        where.push(["title", "LIKE", "%"+this.targetSearch+"%"]);
      var targetClass=this.fieldDesc?.property?.target;
      this.targetItems=(await api.list(targetClass, where, "{uuid,title,properties}", null, 20)).map(item=>({
        text: item.title,
        value: item.uuid,
        ...(this.fieldDesc?.property?{property: item}:{}),
        ...(this.fieldDesc?.brand?{brand: item}:{}),
      }));
    },
  },
  created() {
    this.loadTargetItems();
  },
}
</script>
